import * as ProgressPrimitive from "@radix-ui/react-progress";
import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";

/** 0–100; renders role="progressbar" with the value for assistive technology. */
export function Progress({
  value,
  className,
  ...props
}: { value: number } & Omit<ComponentProps<typeof ProgressPrimitive.Root>, "value">) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <ProgressPrimitive.Root
      value={clamped}
      className={cn("bg-muted relative my-2 h-2 w-full overflow-hidden rounded-full", className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn("h-full transition-all", clamped >= 100 ? "bg-destructive" : "bg-primary")}
        style={{ width: `${clamped}%` }}
      />
    </ProgressPrimitive.Root>
  );
}
